import { RefObject } from 'react';
import { CurrentUserResponseType } from '../api';
import { KvEmbedResourceService } from './KvEmbedResourceService';
import { KvEmbedTrackingService, TrackingParamsType } from './KvEmbedTrackingService';
import TrackingParamsMapper from './KvEmbedTrackingDataMapper';

export class KvEmbedContentService {
  static initShowcaseEmbedContentService(embedId: string, pagePath = '', embedRef: RefObject<HTMLDivElement>, trackingData: CurrentUserResponseType): () => void {
    const sourceInstance = KvEmbedResourceService.initEmbedShowcase(embedId, pagePath);
    new KvEmbedContentService(sourceInstance, embedRef, trackingData);

    return sourceInstance.unloadSource;
  }
  static initPresentationEmbedContentService(embedId: string, embedRef: RefObject<HTMLDivElement>, trackingData?: CurrentUserResponseType): () => void {
    const sourceInstance = KvEmbedResourceService.initEmbedPresentation(embedId);
    new KvEmbedContentService(sourceInstance, embedRef, trackingData);

    return sourceInstance.unloadSource;
  }

  private readonly resource: KvEmbedResourceService;
  private readonly trackingData?: CurrentUserResponseType;

  private subscription = (): void => {
    if (!this.trackingData) return;
    this.trackKvData(TrackingParamsMapper.mapToParams(this.trackingData));
  };

  private trackKvData = (data: TrackingParamsType): void => {
    if (!TrackingParamsMapper.hasIdentity(data)) return;
    if (!this.resource.isSourceLoaded() || !this.embedRef.current) return;
    if (KvEmbedTrackingService.pushIfReady(data)) return;
    void KvEmbedTrackingService.trackData(data);
  };

  protected constructor(
    resource: KvEmbedResourceService,
    private readonly embedRef: RefObject<HTMLDivElement>,
    trackingData?: CurrentUserResponseType
  ) {
    this.resource = resource;
    this.trackingData = trackingData;

    this.resource.addSubscription(this.subscription);

    if (this.embedRef.current && this.trackingData && TrackingParamsMapper.hasIdentity(TrackingParamsMapper.mapToParams(this.trackingData))) {
      this.resource.loadSource();
    }
  }
}
